import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef, useCallback } from 'react';
import { useTableCheckboxCellClassNames } from './utils/useTableCheckboxCellClassNames';
import { TableCheckboxCellRoot, TableCheckboxCellCheckbox } from './style';
import { tableCheckboxCellRootTestId, TABLE_CHECKBOX_CELL_CLASS_PREFIX } from './constants';
export var TableCheckboxCell = forwardRef(function TableCheckboxCell(_ref, ref) {
  var className = _ref.className,
      checked = _ref.checked,
      checkedIcon = _ref.checkedIcon,
      isHeader = _ref.isHeader,
      restProps = _objectWithoutProperties(_ref, ["className", "checked", "checkedIcon", "isHeader"]);

  var classNameComponents = useTableCheckboxCellClassNames(TABLE_CHECKBOX_CELL_CLASS_PREFIX, className);
  var onCheckboxClick = useCallback(function (e) {
    return e.preventDefault();
  }, []);
  return React.createElement(TableCheckboxCellRoot, Object.assign({
    "data-testid": tableCheckboxCellRootTestId
  }, restProps, {
    contentAlignX: "center",
    className: classNameComponents.Root,
    ref: ref,
    isHeader: isHeader
  }), React.createElement(TableCheckboxCellCheckbox, {
    checked: checked,
    checkedIcon: checkedIcon,
    onClick: onCheckboxClick
  }));
});
TableCheckboxCell.defaultProps = {};